import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

import { openDialog, hideDialog } from '../../actions/index';
import NeuriteGrid from '../../components/neurite_grid';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { getData } from '../../dataLib';

//components
import FloatNumberFormatInput from '../../components/float_number_input_formatter';

const styles = theme => ({
    root: {
        margin: theme.spacing(2)
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    Typography: {
        margin: 'auto'
    },
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 250,
        margin: '10px 8px 20px 0',
    },
    totales: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 450,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    label: {
        textAlign: 'left',
        marginRight: 5,
        marginLeft: 15,
        fontSize: 13,
    },
    grid:{
        marginBottom: 20
    }
});

class CierreSemanalResumenBanco extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bancos: [],
            total: 0.0
        }
    }

    getBancos = () => {
        getData('VIngresosResumen?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia,
            (response) => {
                this.setState({ ...this.state, bancos: response.data, total: this.calculateTotal(response.data) + this.props.arcadeCompl })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching bancos'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    }

    calculateTotal = (rows) => {
        let total = 0.0;
        rows.forEach((r) => {
            total += parseFloat(r.sumReal);
        })

        return parseFloat(total.toFixed(2));
    }

    componentDidMount = () => {
        this.getBancos();
    }

    editIngreso = (ingreso) => {
        this.props.openDialog('Arqueo', {
            centroId: this.props.centroDiaSelected.centro.id,
            fecha: ingreso.fecha,
            okHandler: (total) => {
                const newIngresos = this.state.bancos.map((i) => {
                    if (i.fecha === ingreso.fecha) {
                        return { ...i, sumReal: total };
                    }
                    else return i;
                });
                this.setState({ ...this.state, bancos: newIngresos, total: this.calculateTotal(newIngresos) })
            },
            disabled: this.props.isSemanaCerrada
        }, uuidv4(), true, "xs")
    }

    render() {
        const { classes } = this.props;

        if (this.state.bancos.length === 0) {
            return (<div></div>);
        }

        return (
            <div className={classes.root}>
                <div className={classes.grid}>
                    <NeuriteGrid
                        id="c_s_r_b"
                        columns={[
                            { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 100 },
                            { key: 'sumReal', name: 'Importe', editable: false, dragable: false, type: 'float', width: 100 },
                        ]}
                        rows={this.state.bancos}
                        //buttonEdit={false}
                        buttonEdit={!this.props.isSemanaCerrada}
                        buttonDelete={false}
                        buttonNew={false}
                        enableSelection={false}
                        onEditClick={this.editIngreso}
                    />
                </div>

                <div className={classes.total}>
                    {/* <p style={{ margin: 0 }}>Total Bancos</p> */}
                    <Typography variant="subtitle2" className={classes.label}>Arqueo arcade regularización</Typography>

                    <TextField
                        id="total"
                        disabled
                        value={this.props.arcadeCompl}
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        variant="outlined"
                    />
                </div>

                <div className={classes.total}>
                    {/* <p style={{ margin: 0 }}>Total Bancos</p> */}
                    <Typography variant="subtitle2" className={classes.label}>Total Arqueos</Typography>

                    <TextField
                        id="total"
                        disabled
                        value={this.state.total}
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        variant="outlined"
                    />
                </div>

                <div className={classes.total}>
                    {/* <p style={{ margin: 0 }}>Gastos Caja General</p> */}
                    <Typography variant="subtitle2" className={classes.label}>Gastos Caja General</Typography>
                    <TextField
                        id="total"
                        disabled
                        value={this.props.gastos}
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        variant="outlined"
                    />
                </div>

                <div className={classes.total}>
                    <p style={{ margin: 15 }}>Total Bancos</p>

                    <TextField
                        id="total"
                        disabled
                        value={this.state.total + this.props.gastos}
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        variant="outlined"
                    />
                </div>

                <div className={classes.bottomBtn}>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Atrás</Button>
                </div>
            </div>
        );
    }
}


CierreSemanalResumenBanco.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    user: PropTypes.object,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    //parameters
    gastos: PropTypes.number.isRequired,
    arcadeCompl: PropTypes.number.isRequired

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isSemanaCerrada: state.centroDiaSelected.isSemanaCerrada,
        user: state.oidc.user
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
    }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalResumenBanco));